export default "__VITE_ASSET__o9W5G5Du__"